import { IOrder } from '../../../models/purchase-history';
import ILineItem from '../../../models/line-item';
import {
  IOrderDetailsRequest,
  IOverrideAttribute,
} from '../../../models/order-details';
import { CallOrigin } from '../../../models/common';

export const sliceLongText = (text: string, maxLength: number) => {
  if (text === null || text === undefined) return '';
  return text.length > maxLength ? `${text.slice(0, maxLength - 3)}...` : text;
};

export const generateOrderOrigin = (order: IOrder | ILineItem) => {
  if (
    (order as IOrder)?.orderOrigin === undefined &&
    (order as ILineItem)?.detailsSource === undefined
  )
    return '---';
  if (
    (order as IOrder)?.orderOrigin === 'online' ||
    (order as ILineItem)?.detailsSource === 'online'
  ) {
    return 'Online';
  }
  if (
    (order as IOrder)?.orderOrigin === undefined &&
    (order as ILineItem)?.detailsSource === 'InStore'
  )
    return 'In Store';
  return (order as IOrder)?.orderOrigin;
};

const getOrderType = (
  orderNumber: string | undefined,
): 'ONLINE' | 'INSTORE' => {
  if (orderNumber && (orderNumber[0] === 'W' || orderNumber[0] === 'C')) {
    return 'ONLINE';
  }
  return 'INSTORE';
};

export const generateOrderDetailsRequest = (
  {
    transactionType,
    transactionId,
    registerNumber,
    salesDate,
    storeNumber,
    orderNumber,
    orderNumbers,
    accountIdValue,
    accountIdType,
  }: IOrder,
  customerType: string,
  svocID: string,
  timezone: string,
  requestOriginatedFrom: CallOrigin = 'purchaseHistory',
): IOrderDetailsRequest => {
  const filteredOrderNumber = orderNumber ?? orderNumbers?.[0];
  const orderType = getOrderType(filteredOrderNumber);

  const overrideAttributes: IOverrideAttribute[] = [];
  if (accountIdValue) {
    overrideAttributes.push({ name: 'accountIdValue', value: accountIdValue });
    if (accountIdType)
      overrideAttributes.push({ name: 'accountIdType', value: accountIdType });
  }
  const overrideAttributesList: IOverrideAttribute[] | undefined =
    overrideAttributes.length > 0 ? overrideAttributes : undefined;

  if (customerType === 'b2b' && orderType === 'ONLINE') {
    if (transactionType === 'R') {
      return {
        orderDetailsRequest: {
          searchType: 'online',
          registerNumber: registerNumber ?? 0,
          salesDate: salesDate ?? '',
          storeNumber: storeNumber ?? 0,
          transactionId: transactionId ?? 0,
          transactionType: transactionType ?? '',
          orderNumber: filteredOrderNumber ?? '',
          customerAccountId: svocID,
          groupAndSortBy: {
            groupBy: 'fulfillmentType',
            filterResponse: true,
          },
          requestOriginatedFrom,
          timezone,
          ...(overrideAttributesList && { overrideAttributesList }),
        },
      };
    }
    return {
      orderDetailsRequest: {
        searchType: 'online',
        orderNumber: filteredOrderNumber ?? '',
        customerAccountId: svocID,
        groupAndSortBy: {
          groupBy: 'fulfillmentType',
          filterResponse: true,
        },
        requestOriginatedFrom,
        timezone,
        ...(overrideAttributesList && { overrideAttributesList }),
      },
    };
  }
  if (customerType === 'b2b' && orderType === 'INSTORE') {
    return {
      orderDetailsRequest: {
        searchType: 'instore',
        registerNumber: registerNumber ?? 0,
        salesDate: salesDate ?? '',
        storeNumber: storeNumber ?? 0,
        transactionId: transactionId ?? 0,
        orderNumber: filteredOrderNumber ?? '',
        customerAccountId: svocID,
        groupAndSortBy: {
          groupBy: 'fulfillmentType',
          filterResponse: true,
        },
        requestOriginatedFrom,
        timezone,
        ...(overrideAttributesList && { overrideAttributesList }),
      },
    };
  }

  return {
    orderDetailsRequest: {
      searchType: orderType?.toLowerCase(),
      orderNumber: filteredOrderNumber ?? '',
      requestOriginatedFrom,
      timezone,
      ...(overrideAttributesList && { overrideAttributesList }),
    },
  };
};
